module.exports = __webpack_public_path__ + "static/media/ocean_waves.4ffddb7b.mp3";